<template>
    <div>
        <img
            :src="getImage(data.value)"
            class="certificate__input--image"
        />
    </div>
</template>

<script>
export default {
    name: 'CertificateInputImage',
    props: {
        id: String,
        data: Object,
    },
    methods: {
        getImage(file) {
            if (file) {
                const { host, original_file: original, urls } = file;
                if (urls && urls.lg) {
                    return urls.lg;
                }
                if (host) {
                    return `/storage/${host}/lg/${original}`;
                }
            }
            return '/img/certificate_bg.png';
        },
    },
};
</script>

<style scoped>
.certificate__input--image {
    width: 100%;
    height: 100%;
    position: absolute;
}
</style>
